import { Tabs } from 'antd';
import { useNavigate, useLocation, Outlet } from 'react-router';
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';

const SubscriptionAndInvoices = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState('subscriptions');

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/invoices')) {
      setActiveKey('invoices');
    } else if (path.includes('/billing-details')) {
      setActiveKey('billing-details');
    } else {
      setActiveKey('subscriptions');
    }
  }, [location.pathname]);

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    const basePath =
      location.pathname.split('/subscriptions')[0] + '/subscriptions';

    switch (key) {
      case 'subscriptions':
        navigate(basePath);
        break;
      case 'invoices':
        navigate(`${basePath}/invoices`);
        break;
      case 'billing-details':
        navigate(`${basePath}/billing-details`);
        break;
    }
  };

  const tabItems = [
    {
      key: 'subscriptions',
      label: 'Subscriptions',
      children: <Outlet />,
    },
    {
      key: 'invoices',
      label: 'Billing & Invoices',
      children: <Outlet />,
    },
    {
      key: 'billing-details',
      label: 'Billing Details',
      children: <Outlet />,
    },
  ];

  return (
    <div className={styles.container}>
      <Tabs activeKey={activeKey} onChange={handleTabChange} items={tabItems} />
    </div>
  );
};

export default SubscriptionAndInvoices;
